<template>
  <div class="extra-padding-bottom">
    <h2>Atoms</h2>

    <h2>Solid Border</h2>

    <div class="row debug">
      <div class="span-6-lg offset-5-lg span-6-md offset-5-md relative border-blue">
        
        <div class="ratio-4-3 ind-2">
          <h1>Content</h1>
          <p>Lorem Ipsum</p>
        </div>
        
      </div>
    </div>

    <h2>Hatch Background</h2>

    <div class="row debug">
      <div class="span-6-lg offset-5-lg span-6-md offset-5-md relative">
        
        <div class="ratio-4-3 ind-2">
          <h1>Content</h1>
          <p>Lorem Ipsum</p>
        </div>

        <span-background></span-background>
      </div>
    </div>

    <h2>Gradient Background</h2>
    
    <div class="row">
      <div class="span-6-lg offset-5-lg span-6-md offset-5-md bg-gradient ratio-4-3"></div>
    </div>

    <h2>Crosshair Background</h2>

    <div class="row">
      <div class="span-6-lg offset-5-lg span-6-md offset-5-md relative">

        <div class="ratio-4-3 debug">
          <h1>Content</h1>
          <p>Lorem Ipsum</p>
        </div>

        <crosshair-background></crosshair-background>
      </div>
    </div>

    <h2>Combined Hatch/Crosshair</h2>

    <div class="row debug">
      <div class="span-6-lg offset-5-lg span-6-md offset-5-md relative">

        <div class="ratio-4-3 ind-2">
          <h1>Content</h1>
          <p>Lorem Ipsum</p>
        </div>

        <crosshair-background></crosshair-background>
        <span-background></span-background>

      </div>
    </div>

    <h2>Image</h2>

    <div class="row debug">
      <div class="span-6-lg offset-5-lg span-6-md offset-5-md relative">
        <div class="ratio-4-3 ind-2">
          <image-component v-bind:image="example_image"></image-component>
        </div>
      </div>
    </div>

    <h2>Video</h2>

    <div class="row debug">
      <div class="span-6-lg offset-5-lg span-6-md offset-5-md relative">
        <div class="ratio-4-3 ind-2">
          <video-component v-bind:video="example_video"></video-component>
        </div>
      </div>
    </div>


    <h2>Static SVGs/SVG Icons</h2>

    <div>
      <component v-bind:is="current_svg"></component>
    </div>
    <h3>select from dropdown</h3>
    <select svg-select v-on:change="change_svg">
      <option v-for="component in svg_list" v-bind:key="component">{{component}}</option>
    </select>

    <h2>Radio Buttons</h2>

    <radio></radio>
    <radio type="incorrect"></radio>
    <radio type="correct"></radio>

    <h2>Arrows</h2>

    <arrow type="next"></arrow>
    <arrow type="prev"></arrow>
    <arrow type="plus"></arrow>

    <div class="navbar-example ind-top">
      <h3>navbar</h3>
    </div>

  </div>
</template>

<script>

  // atoms
  import span_background from '../../components/atoms/span_background'
  import crosshair_background from '../../components/atoms/crosshair_background'
  import radio from '../../components/atoms/radio'
  import arrow from '../../components/atoms/arrow'
  import image_component from '../../components/atoms/image_component'
  import video_component from '../../components/atoms/video_component'

  import svg from '../../components/svg'

  export default {
    components: {
      'span-background': span_background,
      'crosshair-background': crosshair_background,
      'radio': radio,
      'arrow': arrow,
      'image-component': image_component,
      'video-component': video_component,
      ...svg
    },
    data () {
      return {
        current_svg: 'correct',
        example_image: 'https://s3-us-west-2.amazonaws.com/fwov-vpv/temp.png',
        example_video: 'https://www.youtube.com/watch?v=rV1xGALlamg',
      }
    },
    computed: {
      svg_list () {
        let temp = []
        for (var key in svg) {
          temp.push(key)
        }
        return temp
      }
    },
    methods: {
      change_svg (svg) {
        var el = document.querySelector('[svg-select]')
        this.current_svg = el.value
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../styles/variables';

  h2 {
    margin: 72px auto;
    text-align: center;
  }

  .navbar-example {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 96px;
    background: $white-solid;
    box-shadow: 0 -2px 5px 0 rgba(0,0,0,0.05);
    @media screen and (max-width: $sm-max) {
      height: 60px;
    }
  }
</style>


// WEBPACK FOOTER //
// atoms.vue?32e43961